// ReadOnlyBanner — fixed banner across the top of cv-web when the signed-in
// user has no active membership. Editor is read-only; AI is locked; tokens
// (if any) can still be spent on print/export.

import { useAuth } from './AuthProvider';

interface Props {
  onUpgrade?: () => void;
  onSignIn?: () => void;
}

export default function ReadOnlyBanner({ onUpgrade, onSignIn }: Props) {
  const { session, canEdit, loading, balance, membership } = useAuth();

  if (loading) return null;
  if (canEdit) return null;

  if (!session) {
    return (
      <div className="cv-banner cv-banner-signin" role="status">
        <span>Read-only mode. Sign in to edit and unlock AI features.</span>
        <button className="cv-banner-cta" onClick={onSignIn}>Sign in</button>
      </div>
    );
  }

  const reason = membership?.status === 'canceled' ? 'Membership canceled'
    : membership?.status === 'past_due' ? 'Payment past due'
    : membership?.status === 'expired'  ? 'Membership expired'
    : 'No active membership';

  return (
    <div className="cv-banner cv-banner-readonly" role="status">
      <span>{reason} — read-only mode. {balance > 0 && `${balance} tokens available for print/export.`}</span>
      <button className="cv-banner-cta" onClick={onUpgrade}>Reactivate</button>
    </div>
  );
}
